<template>
  <v-container id="tab-factura" fluid>
    <v-data-table
      v-model="facturaSeleccionada"
      :headers="headers"
      :items="facturas.data"
      :page-count="facturas.last_page"
      :page="facturas.current_page"
      :server-items-length="facturas.total"
      disable-sort
      show-select
      single-select
      :footer-props="{
        itemsPerPageOptions: [5]
      }"
      @update:options="getData($event)"
    >
      <template v-slot:[`item.totalS`]="{ item }">
        <span> {{ simboloMoneda(item.moneda_id) + ' ' + item.total }} </span>
      </template>
      <template v-slot:[`item.saldoS`]="{ item }">
        <span> {{ simboloMoneda(item.moneda_id) + ' ' + item.saldo }} </span>
      </template>
    </v-data-table>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Filtros
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="5">
              <v-text-field v-model="numeroFactura" color="gold" label="Número factura" clearable />
            </v-col>
            <v-col cols="7">
              <v-select v-model="proveedor" color="gold" :items="proveedores" label="Proveedor" item-value="id" item-text="nombre" clearable>
                <template v-slot:item="{ attrs, item, on }">
                  <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                    <v-list-item-content>
                      <v-list-item-title v-text="contactoText(item)" />
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-col cols="5">
              <v-menu ref="fminima" v-model="fminima" :close-on-content-click="false" :return-value.sync="fMin" transition="scale-transition" min-width="290px" offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="fMin" prepend-inner-icon="mdi-calendar-outline" color="gold" label="Fecha vencimiento mínima" readonly clearable v-on="on" />
                </template>
                <v-date-picker v-model="fMin" color="gold" landscape scrollable locale="es-419">
                  <v-spacer />
                  <v-btn color="gold" large @click="fminima = false">
                    Cancelar
                  </v-btn>
                  <v-btn color="gold" large @click="$refs.fminima.save(fMin)">
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="5">
              <v-menu ref="fmaxima" v-model="fmaxima" :close-on-content-click="false" :return-value.sync="fMax" transition="scale-transition" min-width="290px" offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="fMax" prepend-inner-icon="mdi-calendar-outline" color="gold" label="Fecha vencimiento máxima" readonly clearable v-on="on" />
                </template>
                <v-date-picker v-model="fMax" color="gold" landscape scrollable locale="es-419">
                  <v-spacer />
                  <v-btn color="gold" large @click="fmaxima = false">
                    Cancelar
                  </v-btn>
                  <v-btn color="gold" large @click="$refs.fmaxima.save(fMax)">
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2">
              <v-btn color="gold" class="ma-2" @click="readDataFromAPI(1)">
                Aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row class="mt-8">
      <v-col align-self="center" cols="2">
        <span>Definir monto personalizado: </span>
      </v-col>
      <v-col cols="2" class="pa-0">
        <v-text-field v-model="totalSeleccionado" color="gold" type="number" step="0.01" label="Total a pagar" :disabled="bloquear" @change="comprobarMonto()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'TabFactura',
    props: {
      toggleReset: {
        type: Boolean,
        required: true,
        default: false,
      },
      bloquear: {
        type: Boolean,
        required: true,
        default: false,
      },
      monedas: {
        type: Array,
        default: function () {
          return []
        },
        required: false,
      },
    },
    data () {
      return {
        fminima: false,
        fmaxima: false,
        headers: [
          { text: 'Número', value: 'numero' },
          { text: 'Proveedor', value: 'nombre' },
          { text: 'Fecha vencimiento', value: 'fecha_vencimiento' },
          { text: 'Total', value: 'totalS' },
          { text: 'Saldo', value: 'saldoS' },
        ],
        facturas: [],
        facturaSeleccionada: [],
        fMin: null,
        fMax: null,
        proveedores: [],
        proveedor: null,
        numeroFactura: '',
        totalSeleccionado: 0,
        objetoAPagar: {
          totalAPagar: 0,
          monedaId: 1,
          objetoPago: null,
          monto: 0,
          impuestos: 0,
          percepciones: 0,
          caso: 'Factura',
        },
      }
    },
    watch: {
      toggleReset () {
        this.totalSeleccionado = 0
        this.proveedor = null
        this.fMin = null
        this.fMax = null
        this.facturaSeleccionada = []
        this.numeroFactura = ''
      },
      facturaSeleccionada (val) {
        if (val.length !== 0) {
          this.totalSeleccionado = val[0].saldo
          // para pago de facturas el total, maximo y monto son lo mismo
          this.objetoAPagar.totalAPagar = val[0].saldo
          this.objetoAPagar.monedaId = val[0].moneda_id
          this.objetoAPagar.objetoPago = val
          this.objetoAPagar.monto = 0
          this.objetoAPagar.impuestos = 0
          this.objetoAPagar.percepciones = 0
        } else {
          this.resetObjetoAPagar()
        }
        this.enviarPadre()
      },
    },
    created () {
      this.getContactos()
    },
    methods: {
      resetObjetoAPagar () {
        this.objetoAPagar.totalAPagar = 0
        this.objetoAPagar.monedaId = 1
        this.objetoAPagar.objetoPago = null
        this.objetoAPagar.monto = 0
        this.objetoAPagar.impuestos = 0
        this.objetoAPagar.percepciones = 0
        this.totalSeleccionado = 0
      },
      comprobarMonto () {
        if (this.facturaSeleccionada.length === 0) {
          this.$store.commit('toast/show', { tipo: 'info', messages: ['Debe seleccionar una factura.'] })
          this.totalSeleccionado = 0
        } else if (this.facturaSeleccionada[0].saldo < this.totalSeleccionado) {
          this.$store.commit('toast/show', { tipo: 'info', messages: ['El monto no puede superar el saldo de la factura seleccionada.'] })
          this.totalSeleccionado = 0
        } else if (this.totalSeleccionado < 0) {
          this.$store.commit('toast/show', { tipo: 'info', messages: ['El monto debe ser una valor positivo.'] })
          this.totalSeleccionado = 0
        } else {
          this.objetoAPagar.totalAPagar = this.totalSeleccionado
          this.enviarPadre()
        }
      },
      enviarPadre () {
        this.$emit('nuevosTotales', this.objetoAPagar)
      },
      simboloMoneda (monedaId) {
        return (this.monedas.length !== 0) ? this.monedas.find(e => e.id === monedaId).simbolo : '$'
      },
      getData (data) {
        this.readDataFromAPI(data.page)
      },
      readDataFromAPI: async function (page = 1) {
        this.$store.dispatch('axiosMod/getData', {
          url: '/api/factura-proveedor/pagos' + '?page=' + page + '&nfactura=' + this.numeroFactura + '&fmin=' + this.fMin + '&fmax=' + this.fMax + '&proveid=' + this.proveedor,
        }).then(response => {
          this.facturas = response
          this.loading = false
          this.facturaSeleccionada = []
        })
      },
      getContactos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contactos' }).then(response => { this.proveedores = response })
      },
      contactoText (item) {
        const rs = item.razon_social
        if (rs !== null) {
          return item.nombre + ' - ' + rs
        }
        return item.nombre
      },
    },
  }
</script>
